import PropTypes from 'prop-types';
import React from 'react';
import { branch, renderNothing } from 'recompose';
import Carousel from 'nuka-carousel';
import Icon, { GLYPHS } from '../../components/Icon';
import { timeShape } from '../../shapes';
import TimeSlot from './TimeSlot';

const SLIDE_WIDTH = '54px';

const renderIfTimes = noTimes =>
  branch(
    noTimes,
    renderNothing
  );
const enhance = renderIfTimes(props => props.times.length === 0);

const sliderControls = [{
  // eslint-disable-next-line react/prop-types
  component: ({ previousSlide, currentSlide }) => (
    <button
      className="c-date-slider__prev"
      onClick={previousSlide}
      disabled={currentSlide === 0}
    >
      <Icon glyph={GLYPHS.PREV_WEEK} size="small" />
    </button>
  ),
  style: {
    position: 'static',
    order: -1,
  },
}, {
  // eslint-disable-next-line react/prop-types
  component: ({ nextSlide, currentSlide, slideCount, slidesToScroll }) => (
    <button
      className="c-date-slider__next"
      onClick={nextSlide}
      disabled={currentSlide + slidesToScroll >= slideCount}
    >
      <Icon glyph={GLYPHS.NEXT_WEEK} size="small" />
    </button>
  ),
  style: {
    position: 'static',
    order: 1,
  },
}];
const sliderSettings = {
  className: 'c-time-slider',
  dragging: true,
  speed: 500,
  cellAlign: 'left',
  slideWidth: SLIDE_WIDTH,
  decorators: sliderControls,
  slidesToScroll: 'auto',
};

const TimeSlider = ({ times, timezone, selectedTime, setTime }) => (
  <Carousel
    {...sliderSettings}
  >
    { times.map(item => (
      <TimeSlot
        key={item.time}
        item={item}
        timezone={timezone}
        selectedTime={selectedTime}
        setTime={setTime}
      />
    )) }
  </Carousel>
);

TimeSlider.propTypes = {
  times: PropTypes.arrayOf(timeShape),
  timezone: PropTypes.string,
  selectedTime: PropTypes.string,
  setTime: PropTypes.func.isRequired,
};
TimeSlider.defaultProps = {
  timezone: null,
  times: [],
};

export default enhance(TimeSlider);



// WEBPACK FOOTER //
// ./src/app/times/components/TimeSlider.jsx